var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',[_c('CCard',[_c('CCardHeader',[_vm._v(" "+_vm._s(_vm.$t('cert.MyCertificate'))+" ")]),_c('CCardBody',[_c('CertTable')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }